import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import ffglogo from "../images/ffg.svg"
import { HeaderText } from "../theme/Typography"
import { onPhone, onTablet } from "../theme/MediaQueries"

const StyledHeader = styled.header`
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  & > * {
    flex: 1;
  }
  margin: 0 16px;

  ${onPhone} {
    height: 44px;
  }
`

const LogoContainer = styled.div`
  ${onPhone} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const Logo = styled.img`
  all: unset;
  height: 24px;
  ${onPhone} {
    height: 12px;
  }
`

const Header = ({ children }) => (
  <StyledHeader>
    <LogoContainer>
      <Logo src={ffglogo} />
    </LogoContainer>
    {children}
  </StyledHeader>
)

Header.propTypes = {
  text: PropTypes.string,
}

Header.defaultProps = {}

export default Header
